import { StyleCameraOptions } from '../types';

export const getCamera = (map: maplibregl.Map): StyleCameraOptions => {
  return {
    center: map.getCenter(),
    zoom: map.getZoom(),
    pitch: map.getPitch(),
    bearing: map.getBearing(),
  }
}

